import { render } from "./BasicFormDashboard.vue?vue&type=template&id=7da3d838&scoped=true"
import script from "./BasicFormDashboard.vue?vue&type=script&lang=js"
export * from "./BasicFormDashboard.vue?vue&type=script&lang=js"

import "./BasicFormDashboard.vue?vue&type=style&index=0&id=7da3d838&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da3d838"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QBtn,QDialog,QCard,QCardSection});qInstall(script, 'directives', {ClosePopup});
